import { ReactNode } from 'react';

export enum EMenuItemType {
  Header     = 'Header',
  Link       = 'Link',
  Expandable = 'Expandable',
  Queue      = 'Queue'
}

type TMenuItemType = EMenuItemType.Header | EMenuItemType.Link | EMenuItemType.Expandable | EMenuItemType.Queue;

export interface IMenuElementGeneric {
  id: string;
  text: string;
  menuItemType: TMenuItemType;
  link: string;
  alertCount: number;
  showAlert: boolean;
  highlightColor1: string;
  highlightColor2: string;
  order: number;
  queueId: string;
  queueType: string;
  queueCount: number;
  elementKey: string;
}

export interface ChildMenuItem extends IMenuElementGeneric {
  element?: ReactNode;
}

export interface IMenuItem extends IMenuElementGeneric {
  childMenuItems: ChildMenuItem[];
}